var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrafficLightRecognition24 = function SvgTrafficLightRecognition24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 15.333 17 14m0 0 2 1.333M17 14v4",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.829 7.65a1.39 1.39 0 0 1-.099.524 1.248 1.248 0 0 1-.697.7 1.569 1.569 0 0 1-1.208-.042 1.307 1.307 0 0 1-.464-.399 1.748 1.748 0 0 1-.274-.595 2.816 2.816 0 0 1-.087-.7 2.554 2.554 0 0 1 .093-.729c.061-.215.162-.417.297-.595a1.45 1.45 0 0 1 .512-.414 1.6 1.6 0 0 1 .727-.146 1.75 1.75 0 0 1 .622.107 1.3 1.3 0 0 1 .476.298l-.396.455a1.22 1.22 0 0 0-.735-.256.893.893 0 0 0-.679.277 1.09 1.09 0 0 0-.277.709.893.893 0 0 1 .373-.319c.168-.077.35-.116.536-.113.172 0 .344.03.506.092.15.057.287.143.405.253.116.11.209.243.27.39.067.16.101.33.099.503Zm-.664.021a.686.686 0 0 0-.194-.512.711.711 0 0 0-.497-.193.774.774 0 0 0-.277.047.625.625 0 0 0-.369.367.759.759 0 0 0-.054.297.78.78 0 0 0 .054.298.62.62 0 0 0 .366.363.775.775 0 0 0 .551 0 .62.62 0 0 0 .37-.363.779.779 0 0 0 .05-.304Zm2.593-2.421c.225-.004.448.043.652.137.191.089.359.22.491.384.137.178.238.38.298.596.074.247.11.504.107.762.003.255-.036.51-.113.753-.066.218-.174.42-.319.595a1.435 1.435 0 0 1-1.137.512 1.557 1.557 0 0 1-.658-.134 1.385 1.385 0 0 1-.488-.38 1.72 1.72 0 0 1-.298-.596c-.074-.245-.11-.5-.107-.756a2.36 2.36 0 0 1 .116-.76c.068-.216.176-.418.319-.595.136-.162.305-.292.497-.38.2-.093.42-.14.64-.138Zm0 3.132a.762.762 0 0 0 .664-.33 2.016 2.016 0 0 0 0-1.873.762.762 0 0 0-.66-.333.792.792 0 0 0-.674.333 1.578 1.578 0 0 0-.24.944c-.022.328.063.655.24.932a.792.792 0 0 0 .67.327Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.223,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 21a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 21a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm3-8-6 6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgTrafficLightRecognition24;